import { render, staticRenderFns } from "./Dispatchment.vue?vue&type=template&id=57e3eea2"
import script from "./Dispatchment.vue?vue&type=script&lang=js"
export * from "./Dispatchment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports